import React, {useRef, useMemo, useState} from 'react';
import classNames from 'classnames';
import {Form, Formik} from "formik";
import ButtonCommon from "../../../../common/components/ButtonCommon";
import ModalCommon from "../../../../common/components/ModalCommon";
import FieldInput from "../../../../common/components/FieldInput";
import FieldSelect from "../../../../common/components/FieldSelect";
import FieldDatepicker from "../../../../common/components/FieldDatepicker";
import {
  limitFloatValueLength,
  limitIntegerValueLength
} from "../../../../common/utils/form/limitValueLength";
import {
  allowFloatWithDecimals,
  divideThousandsIntegerValue,
  formatStringToNumber
} from "../../../../common/utils/formatting";
import edit from 'common/assets/edit-24px.svg';
import {ddOptions} from "../../../../common/constants/options";
import styles from './styles.module.scss';

const ModalEditRow = ({
                        gridName,
                        onEdit,
                        cities,
                        streets,
                        updateStreets,
                        id,
                        getCities, getStreets,
                        ...initialData
                      }) => {
  const [openVersion, setOpenVersion] = useState(0);
  const handleOpen = () => {
    setOpenVersion(v => v + 1);
  };

  const {
    officialDate,
    cityName, streetName,
    saleDate,
    cityID, streetID, city, street,
    houseNum,
    houseRegisteredArea,
    houseRoomCount,
    floor,
    buildingFloorsCount,
    buildYear,
    houseParking,
    buildingElevator,
    houseYard,
    houseStorage,
    houseRoof,
    houseBalconyCount,
    askingPrice,
    marketingFactor,
    gush,
    helka,
    buildingAge,
    registeredArea,
    estimatePriceFinal,
    gushHelkaTtHelka,
    houseNumber,
    entranceNumber,
    apartmentNumber,
    salePrice,
    estimatePrice,
    brutoAreaType,
    brutoAreaInSquareMeters,
    netAreaType,
    netAreaInSquareMeters,
    pricePerRoom,
    pricePerSquareMeter,
    roomCount,
    floorsCount,
    roomsCount,
    parking,
    elevator,
    roof,
    storage,
    yard,
    lot,
    gallery,
    sellType,
    propertyType,
    soldShare,
    essenseOfRight,
    buildingUnitFunction,
    ...rest
  } = initialData;

  const formikCommonRef = useRef(null);
  const formikSurveyRef = useRef(null);
  const formikTaxAuthorityRef = useRef(null);

  const initialValuesTaxAuthority = useMemo(() => ({
    ...rest,
    gushHelkaTtHelka,
    saleDate: saleDate ?? null,
    city: city && Array.isArray(cities)
      ? cities.find(item => item.label === city) ?? null : null,
    street: street && Array.isArray(streets)
      ? streets.find(item => item.label === street) ?? null : null,
    houseNumber,
    entranceNumber,
    apartmentNumber,
    salePrice,
    estimatePrice,
    brutoAreaType,
    brutoAreaInSquareMeters,
    netAreaType,
    netAreaInSquareMeters,
    buildYear,
    pricePerRoom,
    pricePerSquareMeter,
    roomCount,
    floor,
    floorsCount,
    roomsCount,
    parking,
    elevator,
    roof,
    storage,
    yard,
    lot,
    gallery,
    sellType,
    propertyType,
    soldShare,
    essenseOfRight,
    buildingUnitFunction,
  }), [id, openVersion]);
  const initialValuesSurveyAssets = useMemo(() => ({
    ...rest,
    cityID: cityID && Array.isArray(cities)
      ? cities.filter(item => item.value === cityID)[0] : null,
    streetID: streetID && Array.isArray(streets)
      ? streets.filter(item => item.value === streetID)[0] : null,
    houseNum,
    houseRegisteredArea,
    houseRoomCount,
    floor,
    buildingFloorsCount,
    buildYear,
    houseParking: ddOptions.filter(item => item.value === houseParking)[0] ?? null,
    buildingElevator: ddOptions.filter(item => item.value === buildingElevator)[0] ?? null,
    houseYard: ddOptions.filter(item => item.value === houseYard)[0] ?? null,
    houseStorage: ddOptions.filter(item => item.value === houseStorage)[0] ?? null,
    houseRoof: ddOptions.filter(item => item.value === houseRoof)[0] ?? null,
    houseBalconyCount,
    askingPrice,
    marketingFactor,
  }), [id, openVersion]);
  const initialValuesCommon = useMemo(() => ({
    ...rest,
    officialDate: officialDate ?? null,
    gush,
    helka,
    cityName: cityName && Array.isArray(cities)
      ? cities.filter(item => item.label === cityName)[0] : null,
    streetName: streetName && Array.isArray(streets)
      ? streets.filter(item => item.label === streetName)[0] : null,
    houseNum,
    houseRegisteredArea,
    houseRoomCount,
    floor,
    buildingFloorsCount,
    buildingAge,
    houseParking: ddOptions.filter(item => item.value === houseParking)[0] ?? null,
    buildingElevator: ddOptions.filter(item => item.value === buildingElevator)[0] ?? null,
    houseYard: ddOptions.filter(item => item.value === houseYard)[0] ?? null,
    houseStorage: ddOptions.filter(item => item.value === houseStorage)[0] ?? null,
    houseRoof: ddOptions.filter(item => item.value === houseRoof)[0] ?? null,
    registeredArea,
    estimatePriceFinal
  }), [id, openVersion]);

  const getContent = () => {
    switch (gridName) {
      case 'tax':
        return (
          <Formik
            key={id}
            innerRef={formikTaxAuthorityRef}
            initialValues={initialValuesTaxAuthority}
            onSubmit={() => {
            }}
            enableReinitialize={true}
          >
            {({values, setFieldValue}) => (
              <Form>
                <div className={styles.taxAuthorityForm}>
                  <div className={styles.threeInRow}>
                    <FieldInput fieldId="gushHelkaTtHelka" label="גוש וחלקה"/>
                    <FieldDatepicker
                      fieldId="saleDate"
                      label={'תאריך עסקה'}
                      datepickerStyles={styles.datepicker}
                      boxStyles={styles.datepicker}
                    />
                  </div>
                  <div className={styles.threeInRow}>
                    <FieldSelect
                      fieldId="city"
                      value={values.city}
                      placeholder="עיר"
                      label={'עיר'}
                      options={cities}
                      onChange={(e) => {
                        setFieldValue('street', null);
                        if (values.city) updateStreets(e.value);
                      }}
                    />
                    <FieldSelect
                      fieldId="street"
                      value={values.street}
                      placeholder="רחוב"
                      label={'רחוב'}
                      options={streets}
                      disabled={!values.city}
                    />
                    <FieldInput fieldId="houseNumber" label="בית"/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="entranceNumber" label='כניסה'/>
                    <FieldInput fieldId="apartmentNumber" label="דירה"/>
                    <FieldInput
                      fieldId="salePrice"
                      dir={'ltr'}
                      ltrDirection={true}
                      value={divideThousandsIntegerValue(values.salePrice)}
                      onChange={formatStringToNumber}
                      label={'מחיר מוצהר'}
                    />
                    <FieldInput
                      fieldId="estimatePrice"
                      dir={'ltr'}
                      ltrDirection={true}
                      value={divideThousandsIntegerValue(values.estimatePrice)}
                      onChange={formatStringToNumber}
                      label={'מחיר מוערך'}
                    />
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="brutoAreaType" label="סוג שטח ברוטו"/>
                    <FieldInput fieldId="brutoAreaInSquareMeters" label="שטח ברוטו"/>
                    <FieldInput fieldId="netAreaType" label="סוג שטח נטו"/>
                    <FieldInput fieldId="netAreaInSquareMeters" label="שטח נטו"/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput
                      fieldId="buildYear"
                      onChange={limitIntegerValueLength(4)}
                      label="	שנת בנייה"
                    />
                    <FieldInput fieldId="pricePerRoom" label="מחיר לחדר"/>
                    <FieldInput fieldId="pricePerSquareMeter" label="מחיר למטר"/>
                    <FieldInput fieldId="roomCount" label={'מספר חדרים'}/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput
                      fieldId="floor"
                      onChange={limitIntegerValueLength(2)}
                      label="קומה"
                    />
                    <FieldInput
                      fieldId="floorsCount"
                      onChange={limitIntegerValueLength(2)}
                      label="מספר קומות"
                    />
                    <FieldInput
                      fieldId="roomsCount"
                      onChange={limitIntegerValueLength(2)}
                      label="מספר דירות בבניין"
                    />
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="parking" label="חניה"/>
                    <FieldInput fieldId="elevator" label="מעלית"/>
                    <FieldInput fieldId="roof" label="גג"/>
                    <FieldInput fieldId="storage" label="מחסן"/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="yard" label="חצר"/>
                    <FieldInput fieldId="lot" label="מגרש"/>
                    <FieldInput fieldId="gallery" label="גלריה"/>
                    <FieldInput fieldId="sellType" label="סוג עסקה"/>
                  </div>
                  <div className={styles.fourInRow}>
                    <FieldInput fieldId="propertyType" label="תפקוד יחידה"/>
                    <FieldInput fieldId="soldShare" label="חלקים"/>
                    <FieldInput fieldId="essenseOfRight" label="מהות זכות"/>
                    <FieldInput fieldId="buildingUnitFunction" label="תפקוד בניין"/>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )
      case 'surveyAssets':
        return (
          <Formik
            key={id}
            innerRef={formikSurveyRef}
            initialValues={initialValuesSurveyAssets}
            onSubmit={() => {
            }}
            enableReinitialize={true}
          >
            {({values, setFieldValue}) => (
              <Form>
                <div className={classNames(styles.threeInRow, styles.borderBottom)}>
                  <FieldSelect
                    fieldId="cityID"
                    value={values.cityID}
                    placeholder="עיר"
                    label={'עיר'}
                    options={cities}
                    isAsync={true}
                    onChange={(e) => {
                      if (!values.cityID || values.cityID.value !== e.value) {
                        setFieldValue('streetID', null);
                        if (Boolean(e.value)) {
                          updateStreets(e.value);
                        }
                      }
                    }}
                  />
                  <FieldSelect
                    fieldId="streetID"
                    value={values.streetID}
                    placeholder="רחוב"
                    label={'רחוב'}
                    options={streets}
                    isAsync={true}
                    disabled={!values.cityID}
                  />
                  <FieldInput fieldId="houseNum" label="בית"/>
                </div>
                <div className={styles.fourInRow}>
                  <FieldInput
                    fieldId="houseRegisteredArea"
                    onChange={limitFloatValueLength(6)}
                    label='שטח רשום'
                  />
                  <FieldInput
                    fieldId="houseRoomCount"
                    onChange={limitFloatValueLength(3)}
                    label="מס' חדרים"
                  />
                  <FieldInput
                    fieldId="floor"
                    onChange={limitIntegerValueLength(2)}
                    label="קומה"
                  />
                  <FieldInput
                    fieldId="buildingFloorsCount"
                    onChange={limitIntegerValueLength(2)}
                    label="מס' קומות"
                  />
                </div>
                <div className={styles.fourInRow}>
                  <FieldInput
                    fieldId="buildYear"
                    onChange={limitIntegerValueLength(4)}
                    label="שנת בניה"
                  />
                  <FieldSelect
                    fieldId="houseParking"
                    placeholder="בחר"
                    label="חניה צמודה"
                    options={ddOptions}
                  />
                  <FieldSelect
                    fieldId="buildingElevator"
                    placeholder="בחר"
                    label="מעלית"
                    options={ddOptions}
                  />
                  <FieldSelect
                    fieldId="houseYard"
                    placeholder="בחר"
                    label="חצר"
                    options={ddOptions}
                  />
                </div>
                <div className={styles.fourInRow}>
                  <FieldSelect
                    fieldId="houseStorage"
                    placeholder="בחר"
                    label="מחסן"
                    options={ddOptions}
                  />
                  <FieldSelect
                    fieldId="houseRoof"
                    placeholder="בחר"
                    label="גג"
                    options={ddOptions}
                  />
                  <FieldInput fieldId="houseBalconyCount" label={'שטח מגרש'}/>
                  <FieldInput
                    fieldId="askingPrice"
                    dir={'ltr'}
                    ltrDirection={true}
                    value={divideThousandsIntegerValue(values.askingPrice)}
                    onChange={formatStringToNumber}
                    label={'מחיר מבוקש'}
                  />
                </div>
                <div className={classNames(styles.threeInRow, styles.borderBottom)}>
                  <FieldInput fieldId="marketingFactor" label={'הגורם המשווק'}/>
                </div>
              </Form>
            )}
          </Formik>
        )
      case 'firm':
      case 'shared':
      default:
        return (
          <Formik
            key={id}
            innerRef={formikCommonRef}
            initialValues={initialValuesCommon}
            onSubmit={() => {
            }}
            enableReinitialize={true}
          >
            {({values, setFieldValue}) => (
              <Form>
                <div className={styles.threeInRow}>
                  <FieldDatepicker
                    fieldId="officialDate"
                    label={'תאריך העסקה'}
                    datepickerStyles={styles.datepicker}
                    boxStyles={styles.datepicker}
                  />
                  <FieldInput fieldId="gush" label="גוש"/>
                  <FieldInput fieldId="helka" label="חלקה"/>
                </div>
                <div className={classNames(styles.threeInRow, styles.borderBottom)}>
                  <FieldSelect
                    fieldId="cityName"
                    value={values.cityName}
                    placeholder="עיר"
                    label={'עיר'}
                    options={cities}
                    onChange={(e) => {
                      setFieldValue('streetName', null);
                      if (values.cityName) updateStreets(e.value);
                    }}
                  />
                  <FieldSelect
                    fieldId="streetName"
                    value={values.streetName}
                    placeholder="רחוב"
                    label={'רחוב'}
                    options={streets}
                    disabled={!values.cityName}
                  />
                  <FieldInput fieldId="houseNum" label="בית"/>
                </div>
                <div className={styles.fourInRow}>
                  <FieldInput
                    fieldId="houseRegisteredArea"
                    onChange={limitFloatValueLength(6)}
                    label='שטח רשום'
                  />
                  <FieldInput
                    fieldId="houseRoomCount"
                    onChange={limitFloatValueLength(3)}
                    label="מס' חדרים"
                  />
                  <FieldInput
                    fieldId="floor"
                    onChange={limitIntegerValueLength(2)}
                    label="קומה"
                  />
                  <FieldInput
                    fieldId="buildingFloorsCount"
                    onChange={limitIntegerValueLength(2)}
                    label="מס' קומות"
                  />
                </div>
                <div className={styles.fourInRow}>
                  <FieldInput
                    fieldId="buildingAge"
                    onChange={limitIntegerValueLength(4)}
                    label="גיל בניין"
                  />
                  <FieldSelect
                    fieldId="houseParking"
                    placeholder="בחר"
                    label="חניה צמודה"
                    options={ddOptions}
                  />
                  <FieldSelect
                    fieldId="buildingElevator"
                    placeholder="בחר"
                    label="מעלית"
                    options={ddOptions}
                  />
                  <FieldSelect
                    fieldId="houseYard"
                    placeholder="בחר"
                    label="חצר"
                    options={ddOptions}
                  />
                </div>
                <div className={classNames(styles.fourInRow, styles.borderBottom)}>
                  <FieldSelect
                    fieldId="houseStorage"
                    placeholder="בחר"
                    label="מחסן"
                    options={ddOptions}
                  />
                  <FieldSelect
                    fieldId="houseRoof"
                    placeholder="בחר"
                    label="גג"
                    options={ddOptions}
                  />
                  <FieldInput
                    fieldId="registeredArea"
                    onBeforeInput={(e) => allowFloatWithDecimals(e, 2)}
                    label={'שטח מגרש'}
                  />
                  <FieldInput
                    fieldId="estimatePriceFinal"
                    dir={'ltr'}
                    ltrDirection={true}
                    value={divideThousandsIntegerValue(values.estimatePriceFinal)}
                    onChange={formatStringToNumber}
                    label={'שווי'}
                  />
                </div>
              </Form>
            )}
          </Formik>
        )
    }
  };

  const handleSubmit = async () => {
    switch (gridName) {
      case 'tax':
        await onEdit({id, ...formikTaxAuthorityRef.current?.values});
        break;
      case 'surveyAssets':
        await onEdit({id, ...formikSurveyRef.current?.values});
        break;
      case 'firm':
      case 'shared':
      default:
        await onEdit({id, ...formikCommonRef.current?.values});
        break;
    }
  };

  return (
    <ModalCommon
      header={['עריכת שורה', id].filter(Boolean).join(' - ')}
      customModalTrigger={<ButtonCommon icon={edit} customContainerStyles={styles.buttonShow}/>}
      handleAction={async () => await handleSubmit()}
      getDataOnOpenModal={() => {
        if (cityName || city) {
          const cityID = (cityName || city) && Array.isArray(cities)
            ? cities.filter(item => item.label === cityName || item.label === city)[0].value : null;
          if (cityID) updateStreets(cityID)
        }
        if (cityID) {
          updateStreets(cityID)
        }
        handleOpen();
        setTimeout(() => {
          const valueCommon = streetName && Array.isArray(streets)
            ? streets.filter(item => item.label === streetName)[0] : null;
          const valueTax = street && Array.isArray(streets)
            ? streets.filter(item => item.label === street)[0] : null;
          const valueSurvey = streetID && Array.isArray(streets)
            ? streets.filter(item => item.value === streetID)[0] : null;
          formikCommonRef?.current?.setFieldValue('streetName', valueCommon);
          formikTaxAuthorityRef?.current?.setFieldValue('street', valueTax);
          formikSurveyRef?.current?.setFieldValue('streetID', valueSurvey);
        }, 2000)
      }}
    >
      <div className={styles.modalContent}>{getContent()}</div>
    </ModalCommon>
  );
};

export default ModalEditRow;